module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1584-retro-min.2836410c.jpg";